/**
 * Returns a date and time range based on two date strings
 * @example 10-11 AM
 */
export const eventTimeRange = ({ from, to }: { from: string; to: string }) => {
	const fromDate = new Date(from);
	const toDate = new Date(to);

	const dateTimeFormat = new Intl.DateTimeFormat('en-US', {
		hour: 'numeric',
		minute: 'numeric',
	});

	const fromDateParts = dateTimeFormat.format(fromDate);
	const toDateParts = dateTimeFormat.format(toDate);

	return `${fromDateParts} - ${toDateParts}`;
};
